import styled from 'styled-components';

export const Layout = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 140px 0 80px;
  background: var(--paper);
  color: var(--ink);

  .image-slider {
    height: clamp(18rem, 40vw, 34rem);
    box-shadow: 0 8px 30px rgba(32, 33, 34, 0.04);
    border-radius: 1.6rem;
  }

  @media screen and (max-width: 768px) {
    padding: 120px 0 64px;
  }
`;

export const BackButton = styled.svg`
  display: flex;
  align-items: center;
  justify-content: center;

  width: fit-content;
  height: fit-content;
  /* padding: 1.4rem 1.4rem; */
  /* margin-top: 12vh; */
  border-radius: 1.2rem;
  z-index: 2;
  max-width: 40px;

  transition: all 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    /* background: var(--surface); */
    transition: all 0.2s ease-in-out;
  }
`;

export const P = styled.p`
  color: ${({ theme }) => theme.colors.body};
  width: 100%;
  font-size: 1.6rem;
  z-index: 2;
  position: relative;
`;
